import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useCloneStudyset = () => {
  const router = useRouter();
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  return useMutation(
    trpc.studysets.clone.mutationOptions({
      onSuccess: (id) => {
        queryClient.invalidateQueries({
          queryKey: trpc.studysets.get.queryKey(),
        });
        router.push(`/studysets/${id}`);
        toast.success("Studyset cloned successfully");
      },
      onError: (error) => {
        console.error("Failed to clone studyset", error);
        toast.error(error.message);
      },
    }),
  );
};
